import FavPanel from 'app/common/components/FavPanel'

import {
  useFinancesReportsEnabled,
  getReportTitlesAll as getFinancesReportTitlesAll,
} from '../finances'

import { useCommonReportsEnabled, getReportTitlesAll } from '../Reports'

const emptyArray = []

const FavoritesBar = () => {
  const { reportsEnabled, loading: loadingReports } = useCommonReportsEnabled()
  const favorites = loadingReports ? emptyArray : reportsEnabled

  const { reportsEnabled: reportsEnabledFinances, loading: loadingFinancesReports } =
    useFinancesReportsEnabled()

  const financesFavorites = loadingFinancesReports ? emptyArray : reportsEnabledFinances

  return (
    <>
      <FavPanel
        basePath="/reports"
        favorites={favorites}
        names={getReportTitlesAll()}
        showConditionReg={/^\/(reports)(\/|$)/}
        shallow
      />
      <FavPanel
        basePath="/finances"
        favorites={financesFavorites}
        names={getFinancesReportTitlesAll()}
        showConditionReg={/^\/(finances)(\/|$)/}
      />
    </>
  )
}

export default FavoritesBar
